import { useNavigate } from 'react-router-dom';
import { FrogMascot } from '@/components/FrogMascot';
import { Button } from '@/components/ui/button';

/**
 * 404 Not Found page.
 *
 * Shown when a route does not match any known path.
 * Displays the lost frog mascot with a prompt to return home.
 */
export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex h-full min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <FrogMascot variant="notfound" size="lg" />
      <h1 className="text-2xl font-bold">You seem lost.</h1>
      <p className="text-muted-foreground">This page doesn&apos;t exist.</p>
      <Button variant="accent" onClick={() => navigate('/')}>
        Go Home
      </Button>
    </div>
  );
}
